import axios from "axios"
import { useStoreActions, useStoreState } from "easy-peasy"
import { useEffect, useRef } from "react"
import { Outlet, useNavigate } from "react-router-dom"
import Footer from "./Footer"
import Header from "./Header"
import Nav from "./Nav"
import { useIdleTimeout } from "./hooks/useIdleTimeout"

const Layout = () => {
	useIdleTimeout()
	const Theme = useStoreState((state) => state.Theme)
	const LoggedIn = useStoreState((state) => state.LoggedIn)
	const setLoggedIn = useStoreActions((actions) => actions.setLoggedIn)
	const setToken = useStoreActions((actions) => actions.setToken)
	const navigate = useNavigate()
	const loggedInRef = useRef(LoggedIn)

	useEffect(() => {
		loggedInRef.current = LoggedIn
	}, [LoggedIn])

	// Detect true network loss (browser goes offline)
	useEffect(() => {
		const handleOffline = () => {
			if (!loggedInRef.current) return
			setLoggedIn(false)
			setToken("")
			navigate("/login", { replace: true })
		}
		window.addEventListener("offline", handleOffline)
		return () => window.removeEventListener("offline", handleOffline)
	}, [])

	// Detect backend unreachable (server stopped, connection refused, etc.)
	useEffect(() => {
		const interceptor = axios.interceptors.response.use(
			(response) => response,
			(error) => {
				if (!error.response && loggedInRef.current) {
					setLoggedIn(false)
					setToken("")
					navigate("/login", { replace: true })
				}
				return Promise.reject(error)
			},
		)
		return () => axios.interceptors.response.eject(interceptor)
	}, [])

	// Detect bfcache restore (browser Back from a different domain)
	useEffect(() => {
		const handlePageShow = (e) => {
			if (e.persisted && !loggedInRef.current) {
				navigate("/login", { replace: true })
			}
		}
		window.addEventListener("pageshow", handlePageShow)
		return () => window.removeEventListener("pageshow", handlePageShow)
	}, [])

	let theme
	switch (Theme) {
		case 0:
			theme = "theme-light-blue"
			break
		case 1:
			theme = "theme-dark-blue"
			break
		case 2:
			theme = "theme-light-green"
			break
		case 3:
			theme = "theme-dark-green"
			break
		case 4:
			theme = "theme-white"
			break
		case 5:
			theme = "theme-black"
			break
		default:
			theme = "theme-dark-blue"
	}
	return (
		<div className={`base-theme ${theme}`}>
			<Header />
			<Nav />
			{/* All other routes rendered thru Outlet */}
			<Outlet />
			<Footer />
		</div>
	)
}

export default Layout
